import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { AutobookingAdvert } from 'shared/components/AutobookingForm';
import { cityLocale } from 'shared/modules';
import { getUserName } from 'shared/helpers/users';
import { generateSparesSearchUrl } from 'shared/helpers/urls';
import { getSpareDefaultImage } from 'shared/constants/defaultImages';
import AdvertTitle from 'desktop/components/AdvertTitle/AdvertTitle';
import AdvertDescription from 'shared/components/AdvertDescription/AdvertDescription';
import Info from 'desktop/components/AdvertInfo_Old/AdvertInfo';
import SparepartsAdvertSeller from 'desktop/components/AdvertSeller/SparepartsAdvertSeller';
import AdvertPhotos from 'desktop/components/AdvertPhotos/AdvertPhotos';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Link from 'shared/components/Link/Link';
import currencies from 'shared/constants/json/currency.json';
import { getTitleOrEmpty, numberWithSpaces } from 'shared/helpers/common';
import s from './SparepartItem.css';

const UAH_CURRENCY = currencies.find(item => item.slug === 'uah');
const USD_CURRENCY = currencies.find(item => item.slug === 'usd');

class SparepartItem extends React.Component {
  static propTypes = {
    advertInfo: PropTypes.shape({
      id: PropTypes.number.isRequired,
      active: PropTypes.number.isRequired,
      author: PropTypes.shape().isRequired,
      make: PropTypes.shape().isRequired,
      rubric: PropTypes.shape().isRequired,
      sparetypes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      price: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      photos: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      models: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
      views_count: PropTypes.number,
      year_from: PropTypes.number,
      year_to: PropTypes.number,
      location: PropTypes.shape().isRequired,
      // statuses
      is_new: PropTypes.bool,
      is_used: PropTypes.bool,
      is_original: PropTypes.bool,
      is_analogue: PropTypes.bool,
      in_stock: PropTypes.bool,
      is_under_the_order: PropTypes.bool,
      is_customs_cleared: PropTypes.bool,
      delivery_in_ukraine: PropTypes.bool,
    }).isRequired,
    views: PropTypes.number,
    userId: PropTypes.number,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    options: [],
    description: undefined,
    views: 0,
    userId: null,
    year_from: null,
    year_to: null,
    // statuses
    is_new: false,
    is_used: false,
    is_original: false,
    is_analogue: false,
    in_stock: false,
    is_under_the_order: false,
    is_customs_cleared: false,
    delivery_in_ukraine: false,
  };

  buildInfoLink = (link, obj) => {
    if (!link || !obj || !obj.slug || !obj.title) {
      return null;
    }

    return link ? (
      <Link className={s.infoLink} to={link || undefined}>
        {obj.title}
      </Link>
    ) : null;
  };

  render() {
    const { intl, advertInfo, views, userId } = this.props;
    const {
      id,
      agency: spareAgency,
      active,
      author = {},
      price: prices,
      photos,
      make,
      rubric,
      sparetypes,
      models,
      title,
      description = intl.formatMessage({ id: 'Нет описания' }),
      hot_date: hotDate,
      date_published: published,
      date_created: created,
      location,
      year_from: yearFrom,
      year_to: yearTo,
      is_new: isNew,
      is_used: isUsed,
      is_original: isOriginal,
      is_analogue: isAnalog,
      in_stock: inStock,
      is_under_the_order: isUnderTheOrder,
      is_customs_cleared: isCustomsCleared,
      delivery_in_ukraine: isDelivery,
      vehicle_type: transport,
      contact_name: contactName,
    } = advertInfo;
    const date = hotDate || published || created;
    const isAuto = transport && transport.slug === 'avto';

    const authorName =
      author.first_name && author.last_name
        ? `${author.first_name} ${author.last_name}`
        : author.last_name || null;

    const seoTitle = `${intl.formatMessage({ id: 'Купить' })} ${title}${
      location && location.title
        ? ` ${intl.formatMessage({ id: 'в' })} ${cityLocale(
            location.title,
            intl.locale,
            'genitive',
          )}`
        : ` ${intl.formatMessage({ id: 'в Украине' })}`
    }`;

    const makeLink = isAuto
      ? this.buildInfoLink(`/${generateSparesSearchUrl({ transport, location, make })}`, make)
      : null;

    const modelLinks =
      isAuto && make && make.slug && make.title && models && models.length > 0
        ? models
            .map(model =>
              this.buildInfoLink(
                `/${generateSparesSearchUrl({ transport, location, make, model })}`,
                model,
              ),
            )
            .filter(link => !!link)
        : null;

    let modelsInfoValue = null;
    if (modelLinks && modelLinks.length > 0) {
      modelsInfoValue = modelLinks.map((link, i, { length }) => (
        <span key={link}>
          {link}
          {i + 1 !== length ? ', ' : ''}
        </span>
      ));
    } else if (models && models.length > 0) {
      modelsInfoValue = models
        .map(m => m && m.title)
        .filter(i => i)
        .join(', ');
    }

    const infoList = [
      {
        title: intl.formatMessage({ id: 'Категория' }),
        value: rubric && rubric.title,
      },
      {
        title:
          sparetypes &&
          sparetypes.length > 0 &&
          intl.formatMessage({ id: sparetypes.length > 1 ? 'Типы' : 'Тип' }),
        value:
          sparetypes &&
          sparetypes.length > 0 &&
          sparetypes
            .map(el => el.title)
            .filter(el => !!el)
            .join(', '),
      },
      {
        title: intl.formatMessage({ id: 'Марка' }),
        value: makeLink || (make && make.title),
      },
      {
        title:
          models && models.length > 1
            ? intl.formatMessage({ id: 'Модели' })
            : intl.formatMessage({ id: 'Модель' }),
        value: modelsInfoValue,
      },
      {
        title: (yearFrom || yearTo) && intl.formatMessage({ id: 'Год' }),
        value:
          yearFrom === yearTo
            ? yearFrom
            : `${yearFrom || ''}${yearFrom && yearTo ? ' - ' : ''}${yearTo || ''}`,
      },
    ].filter(item => item && item.value && item.title);

    const statuses = [
      isNew && { title: intl.formatMessage({ id: 'Новый' }) },
      isUsed && { title: intl.formatMessage({ id: 'б/у' }) },
      isOriginal && { title: intl.formatMessage({ id: 'Оригинальный' }) },
      isAnalog && { title: intl.formatMessage({ id: 'Не оригинальный' }) },
      inStock && { title: intl.formatMessage({ id: 'В наличии' }) },
      isUnderTheOrder && { title: intl.formatMessage({ id: 'Под заказ' }) },
      isCustomsCleared && { title: intl.formatMessage({ id: 'Растаможен' }) },
      isDelivery && { title: intl.formatMessage({ id: 'Доставка по Украине' }) },
    ].filter(i => i && i.title);

    const priceList = [UAH_CURRENCY, USD_CURRENCY] // todo duplicate
      .map(currencyItem => [
        prices.find(priceObj => priceObj.currency === currencyItem.slug),
        currencyItem,
      ])
      .filter(([priceObj]) => priceObj)
      .map(([{ value }, currencyItem]) => ({
        value: numberWithSpaces(value),
        currency: getTitleOrEmpty(currencyItem),
      }));

    const agency = spareAgency && spareAgency.id ? spareAgency : null;
    const agencyName = agency && agency.title ? agency.title : getUserName(author);
    const agencyLocation = (location && location.title) || (agency && agency.address);
    const agencyLink = agency && agency.slug ? `/katalog-kompaniy/${agency.slug}` : null;
    const agencyExtraText =
      agency && agency.adverts_count
        ? `${agency.adverts_count} ${intl.formatMessage({ id: 'объявлений' })} `
        : null;
    const agencyLogo = agency ? agency.logo : author.avatar || '';
    return (
      <div className={s.root}>
        <AdvertTitle
          id={id}
          seoTitle={seoTitle}
          views={views || 0}
          title={title}
          prices={priceList}
          dateCreated={date}
          isSpare
        />
        <SparepartsAdvertSeller
          link={agencyLink}
          active={active}
          isSpare
          advertID={id}
          agency={agency}
          avatar={agencyLogo}
          authorID={author.id}
          authorName={contactName || authorName || agencyName}
          transport={transport}
          extraText={agencyExtraText}
          location={agencyLocation || intl.formatMessage({ id: 'Украина' })}
        />
        <div className={s.flexRow}>
          <div className={s.left}>
            <Info infoList={infoList} />
            <AutobookingAdvert advert={advertInfo} title="СТО для {make}" />
          </div>
          <div className={s.right}>
            <AdvertPhotos
              photos={photos}
              defaultImg={getSpareDefaultImage()}
              alt={`${title} - ${intl.formatMessage({ id: 'купить на Автобазаре' })}`}
            />
            <AdvertDescription
              statuses={statuses}
              title={title}
              description={description}
              advert={advertInfo}
            />
          </div>
        </div>{' '}
        {author.id !== userId && (
          <div className={s.flexRow}>
            <div className={s.left} />
            <div className={cx(s.warningBlock, s.right)}>
              <FormattedMessage id="Ввиду наличия на рынке мошеннических схем ни в коем случае не проводите полную или частичную оплату без проверки продавца" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  userId: user.user && user.user.id,
});

export default withStyles(s)(connect(mapStateToProps)(injectIntl(SparepartItem)));



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/components/SparepartItem/SparepartItem.js